/**
 * Monaco language definition for SOQL/SQL hybrid.
 */

export const SOQL_LANGUAGE_ID = 'soql';

/**
 * SOQL language configuration for Monaco.
 */
export const soqlLanguageConfiguration = {
  comments: {
    lineComment: '--',
    blockComment: ['/*', '*/'],
  },
  brackets: [
    ['(', ')'],
  ],
  autoClosingPairs: [
    { open: '(', close: ')' },
    { open: "'", close: "'" },
  ],
  surroundingPairs: [
    { open: '(', close: ')' },
    { open: "'", close: "'" },
  ],
};

/**
 * SOQL token provider (Monarch syntax highlighter).
 */
export const soqlTokensProvider = {
  ignoreCase: true,

  keywords: [
    'SELECT', 'FROM', 'WHERE', 'AND', 'OR', 'NOT', 'IN', 'LIKE',
    'IS', 'NULL', 'TRUE', 'FALSE', 'AS', 'DISTINCT',
    'ORDER', 'BY', 'ASC', 'DESC', 'NULLS', 'FIRST', 'LAST',
    'LIMIT', 'OFFSET', 'GROUP', 'HAVING',
  ],

  aggregateFunctions: [
    'COUNT', 'SUM', 'AVG', 'MIN', 'MAX',
  ],

  dateLiterals: [
    'TODAY', 'YESTERDAY', 'TOMORROW',
    'LAST_WEEK', 'THIS_WEEK', 'NEXT_WEEK',
    'LAST_MONTH', 'THIS_MONTH', 'NEXT_MONTH',
    'LAST_YEAR', 'THIS_YEAR', 'NEXT_YEAR',
    'LAST_N_DAYS', 'NEXT_N_DAYS',
  ],

  operators: [
    '=', '!=', '<>', '<', '<=', '>', '>=',
  ],

  tokenizer: {
    root: [
      // Whitespace
      [/\s+/, 'white'],

      // Comments
      [/--.*$/, 'comment'],
      [/\/\*/, 'comment', '@comment'],

      // Date literals with N_DAYS:N pattern
      [/LAST_N_DAYS:\d+/i, 'constant.date'],
      [/NEXT_N_DAYS:\d+/i, 'constant.date'],

      // Keywords and functions
      [/[a-zA-Z_]\w*/, {
        cases: {
          '@keywords': 'keyword',
          '@aggregateFunctions': 'function',
          '@dateLiterals': 'constant.date',
          '@default': 'identifier',
        },
      }],

      // Custom fields (ending in __c or __r)
      [/[a-zA-Z_]\w*__[cr]\b/i, 'variable.custom'],

      // Numbers
      [/-?\d+\.\d+/, 'number.float'],
      [/-?\d+/, 'number'],

      // Strings
      [/'/, 'string', '@string'],

      // Operators
      [/[=!<>]+/, 'operator'],

      // Punctuation
      [/[(),.*:]/, 'delimiter'],
    ],

    comment: [
      [/[^/*]+/, 'comment'],
      [/\*\//, 'comment', '@pop'],
      [/[/*]/, 'comment'],
    ],

    string: [
      [/[^']+/, 'string'],
      [/''/, 'string.escape'],
      [/'/, 'string', '@pop'],
    ],
  },
};

/**
 * Register the SOQL language with Monaco.
 *
 * @param {object} monaco - Monaco namespace
 */
export function registerSOQLLanguage(monaco) {
  // Register language
  monaco.languages.register({ id: SOQL_LANGUAGE_ID });

  // Set language configuration
  monaco.languages.setLanguageConfiguration(
    SOQL_LANGUAGE_ID,
    soqlLanguageConfiguration
  );

  // Set tokenizer
  monaco.languages.setMonarchTokensProvider(
    SOQL_LANGUAGE_ID,
    soqlTokensProvider
  );
}

export default {
  SOQL_LANGUAGE_ID,
  soqlLanguageConfiguration,
  soqlTokensProvider,
  registerSOQLLanguage,
};
